import { jsx } from "react/jsx-runtime";
import { useRef, useEffect } from "react";
const WaveformBlob = ({ level, size }) => {
  const canvasRef = useRef(null);
  const levelRef = useRef(level);
  useEffect(() => {
    levelRef.current = level;
  }, [level]);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    const dpr = typeof window !== "undefined" && window.devicePixelRatio || 1;
    canvas.width = size * dpr;
    canvas.height = size * dpr;
    ctx.scale(dpr, dpr);
    let raf;
    let t = 0;
    const draw = () => {
      t += 0.04;
      ctx.clearRect(0, 0, size, size);
      const cx = size / 2;
      const cy = size / 2;
      const l = levelRef.current;
      const segments = 120;
      const baseR = size * 0.227;
      const coreR = size * 0.136 + l * 10;
      const coreGrad = ctx.createRadialGradient(cx, cy, 0, cx, cy, coreR);
      coreGrad.addColorStop(0, `rgba(255,255,255,${0.95})`);
      coreGrad.addColorStop(0.6, `rgba(255,140,200,${0.6 + l * 0.3})`);
      coreGrad.addColorStop(1, "rgba(80,20,80,0)");
      ctx.fillStyle = coreGrad;
      ctx.beginPath();
      ctx.arc(cx, cy, coreR, 0, Math.PI * 2);
      ctx.fill();
      for (let ring = 0; ring < 3; ring++) {
        ctx.beginPath();
        for (let i = 0; i <= segments; i++) {
          const a = i / segments * Math.PI * 2;
          const wave = Math.sin(a * (4 + ring) + t * (1 + ring * 0.5)) * (6 + l * 18) + Math.sin(a * (7 + ring) - t * 0.8) * (3 + l * 10);
          const r = baseR + ring * 8 + wave;
          const x = cx + Math.cos(a) * r;
          const y = cy + Math.sin(a) * r;
          if (i === 0) ctx.moveTo(x, y);
          else ctx.lineTo(x, y);
        }
        ctx.closePath();
        ctx.strokeStyle = `hsla(${320 + ring * 20}, 90%, ${70 - ring * 10}%, ${0.7 - ring * 0.18})`;
        ctx.lineWidth = 1.5;
        ctx.stroke();
      }
      raf = requestAnimationFrame(draw);
    };
    draw();
    return () => cancelAnimationFrame(raf);
  }, [size]);
  return /* @__PURE__ */ jsx("canvas", { ref: canvasRef, style: { width: size, height: size }, "aria-hidden": true });
};
export {
  WaveformBlob
};
//# sourceMappingURL=WaveformBlob.js.map
